import callApi from "../../utils/api";
import { API_BASE_URL, json_files } from "../../utils/constants";
import { parseParams } from "../../utils";

const api = callApi(API_BASE_URL || "");

export const IR_SPEECH_CONFIG = json_files.speechConfig.url;

export const UPLOAD_JSON =
  "/v1/api/file/upload-custom/ir?path=IR-SERVICE/configuration";

export const getSpeechConfigInfo = async () => {
  return await fetch(IR_SPEECH_CONFIG)
    .then((data) => data.json())
    .then((res) => res);
};

const jsonUploadParams = new URLSearchParams({
  fileCategory: "IR_SERVICE",
  subFolders: "IR_SPEECH_CONFIG",
  fileType: "speechConfig",
});

export const uploadJson = async (payload) => {
  jsonUploadParams.set("fileType", "speechConfig");
  return api.post(
    parseParams(UPLOAD_JSON, {
      id: payload.id,
      query: jsonUploadParams.toString(),
    }),
    payload.formData,
    {},
    true,
  );
};
